import { Button, Card, CardContent, Divider, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import Footer from '../../Footer/Footer';

const Dental = () => {
    return (
        <Box sx={{ height: 'auto', mt: 5 }}>
            <Link sx={{ position: 'absolute', left: 0, top: 0 }} href="/" underline="none">
                <Button style={{ color: 'rgba(255, 255, 255, 0.689)', padding: '2px 15px', textTransform: 'capitalize', fontSize: '16px', backgroundColor: 'transparent', border: '1px solid #FFFFFF4E', }}>
                    Back To Home
                </Button>
            </Link>
            <Typography sx={{ letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                Dentario Dental Clinic
            </Typography>

            <Divider sx={{ width: '100px', p: 0, m: '-2px auto', border: '1px solid #FFFFFF4E' }} />
            <Divider sx={{ width: '150px', p: 0, m: '4px auto', border: '1px solid #FFFFFF4E' }} />

            <Card sx={{ maxWidth: { xs: 500, md: 900 }, position: 'relative', my: 3, mx: 'auto', top: '0px', backgroundColor: '#1976d200', border: { xs: 'none', md: '1px solid #ffffff14', }, boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px', color: 'rgba(255, 255, 255, 0.689)' }}>
                <Box
                    component="div"
                    className='box third-project'
                    sx={{ height: '350px' }}
                />
                <CardContent>
                    <Box>
                        <Typography sx={{ color: '#ffffffeb', letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                            Key Points of this website
                        </Typography>
                        <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                        <Typography sx={{ mb: 3, mx: 4, fontWeight: 300, letterSpacing: '1px', textAlign: 'justify' }} variant="p" component="div">
                            On this website, users can log in or register using a username, password, or Google authentication (OAuth2).
                            The main point of this website is that users cannot view doctor information unless they log in. On this website, anyone can see the services of dental care. A user can't see the details of a single service without log in.
                        </Typography>
                    </Box>

                    <Typography sx={{ color: '#ffffffeb', letterSpacing: '1px', fontWeight: 500, }} variant="h6" component="div">
                        Job Seekers Functionalities
                    </Typography>
                    <Divider sx={{ width: '100px', p: 0, m: '0px auto 10px auto', border: '1px solid #FFFFFF4E' }} />

                    <Box sx={{ mb: 3, px: 5, display: 'flex', justifyContent: 'center', gap: '5px', flexWrap: 'wrap', }}>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mx: 1, mb: 1 }} variant="p" component="div">JavaScript</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mx: 1, mb: 1 }} variant="p" component="div">ReactJS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1, mx: 1, }} variant="p" component="div">React Router</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1, mx: 1, }} variant="p" component="div">Bootstrap</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1, mx: 1, }} variant="p" component="div">CSS</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1, mx: 1, }} variant="p" component="div">Firebase Authentication</Typography>
                        <Typography sx={{ bgcolor: 'text.secondary', p: 1, borderRadius: '30px', mb: 1, mx: 1, }} variant="p" component="div">Netlify</Typography>
                    </Box>


                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Link sx={{ mx: 1, }} href="https://dentario-dental-clinic.web.app/" target="_blank" underline="none">
                            <Button style={{ backgroundColor: 'transparent', color: 'rgba(255, 255, 255, 0.689)', border: '1px solid #FFFFFF4E', padding: '5px', width: '80px', textTransform: 'capitalize', }}>Live Site</Button>
                        </Link>
                        <Link sx={{ mx: 1 }} href="https://github.com/AH-Likhon/dentario-dental-clinic" target="_blank" underline="none">
                            <Button style={{ backgroundColor: 'transparent', color: 'rgba(255, 255, 255, 0.689)', border: '1px solid #FFFFFF4E', padding: '5px', width: '130px', textTransform: 'capitalize', }}>Client Side Code</Button>
                        </Link>
                    </Box>
                </CardContent>
            </Card>

            <Footer />
        </Box>
    );
};

export default Dental;